/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Meeesh API
 * The Meeesh API

Rate limiting:
- default: 60 requests/min (applies to all routes).
- write: 60 requests/min (applies to POST/PUT/PATCH/DELETE).
- public: 120 requests/min (applies only to redirect tracker).

Some endpoints may set stricter write limits (e.g., earn start/claim).
On limit, the API returns 429 with a single Retry-After (seconds).
For redirect, clients can include X-Device-Id to ensure device-keyed limits.
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ClaimResponseDto,
  ClaimTaskDto,
  EarnControllerListCompleted200,
  EarnControllerListCompletedParams,
  EarnControllerRedirectParams,
  EarnSectionsResponseDto,
  EarnStatusResponseDto,
  EarnTaskResponseDto,
  ErrorResponseDto,
  GenerateRedirectResponseDto,
  SubmitInputDto
} from '.././model';

import { fetcher } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Transitions FSM from idle → started.
- If the task has windows configured: requires an active UTC window.
- If the task has no windows: treated as always-open and allowed.
- Use this when a user begins the task flow (e.g., opens a daily task).
- Response includes `windowStart` and `windowEnd` (may be null) for timers.
- When windows exist but none is active, the call fails and Start should be hidden.
 * @summary Start an Earn task
 */
export const earnControllerStart = (
    id: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<EarnStatusResponseDto | EarnStatusResponseDto>(
      {url: `/earn/tasks/${id}/start`, method: 'POST', signal
    },
      options);
    }
  


export const getEarnControllerStartMutationOptions = <TError = ErrorResponseDto | null | ErrorResponseDto | ErrorResponseDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof earnControllerStart>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof earnControllerStart>>, TError,{id: string}, TContext> => {

const mutationKey = ['earnControllerStart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof earnControllerStart>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  earnControllerStart(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EarnControllerStartMutationResult = NonNullable<Awaited<ReturnType<typeof earnControllerStart>>>
    
    export type EarnControllerStartMutationError = ErrorResponseDto | null | ErrorResponseDto | ErrorResponseDto

    /**
 * @summary Start an Earn task
 */
export const useEarnControllerStart = <TError = ErrorResponseDto | null | ErrorResponseDto | ErrorResponseDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof earnControllerStart>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof earnControllerStart>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getEarnControllerStartMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Validates progress depending on task kind.
- open_link: call after user passed through signed redirect; marks `completed`.
- integration_check: sets `checking`; completion occurs via async signal later.
- internal_event: auto-completes immediately.
- repeatable/milestone: returns current status (auto-completed via events).
May be retried safely; returns current FSM state.
 * @summary Perform check step for an Earn task
 */
export const earnControllerCheck = (
    id: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<EarnStatusResponseDto | EarnStatusResponseDto>(
      {url: `/earn/tasks/${id}/check`, method: 'POST', signal
    },
      options);
    }
  


export const getEarnControllerCheckMutationOptions = <TError = ErrorResponseDto | null | ErrorResponseDto | ErrorResponseDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof earnControllerCheck>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof earnControllerCheck>>, TError,{id: string}, TContext> => {

const mutationKey = ['earnControllerCheck'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof earnControllerCheck>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  earnControllerCheck(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EarnControllerCheckMutationResult = NonNullable<Awaited<ReturnType<typeof earnControllerCheck>>>
    
    export type EarnControllerCheckMutationError = ErrorResponseDto | null | ErrorResponseDto | ErrorResponseDto

    /**
 * @summary Perform check step for an Earn task
 */
export const useEarnControllerCheck = <TError = ErrorResponseDto | null | ErrorResponseDto | ErrorResponseDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof earnControllerCheck>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof earnControllerCheck>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getEarnControllerCheckMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Single entry point for submit_input tasks. Handles auto-start, word validation, and auto-claim.
- Accepts request at any status except "already claimed in current window".
- Auto-starts task if idle or not started.
- Auto-restarts from claimed if in a new window.
- Validates input against secret words configured for the active window.
- On success: auto-claims reward and transitions to `claimed`.
- Unlimited attempts; increments `attempts` counter on wrong answer.
- Requires active window (tasks without windows are rejected).
 * @summary Submit input (secret word) for an Earn task
 */
export const earnControllerInput = (
    id: string,
    submitInputDto: SubmitInputDto,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<EarnStatusResponseDto | EarnStatusResponseDto>(
      {url: `/earn/tasks/${id}/input`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitInputDto, signal
    },
      options);
    }
  


export const getEarnControllerInputMutationOptions = <TError = ErrorResponseDto | null | ErrorResponseDto | ErrorResponseDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof earnControllerInput>>, TError,{id: string;data: SubmitInputDto}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof earnControllerInput>>, TError,{id: string;data: SubmitInputDto}, TContext> => {

const mutationKey = ['earnControllerInput'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof earnControllerInput>>, {id: string;data: SubmitInputDto}> = (props) => {
          const {id,data} = props ?? {};

          return  earnControllerInput(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EarnControllerInputMutationResult = NonNullable<Awaited<ReturnType<typeof earnControllerInput>>>
    export type EarnControllerInputMutationBody = SubmitInputDto
    export type EarnControllerInputMutationError = ErrorResponseDto | null | ErrorResponseDto | ErrorResponseDto

    /**
 * @summary Submit input (secret word) for an Earn task
 */
export const useEarnControllerInput = <TError = ErrorResponseDto | null | ErrorResponseDto | ErrorResponseDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof earnControllerInput>>, TError,{id: string;data: SubmitInputDto}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof earnControllerInput>>,
        TError,
        {id: string;data: SubmitInputDto},
        TContext
      > => {

      const mutationOptions = getEarnControllerInputMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Credits user balance and records ledger entry (idempotent).
- Requires header `Idempotency-Key` to deduplicate retries.
- repeatable: awards all currently available chunks in one call.
- milestone: when milestoneIndex provided, claims that specific milestone. When omitted, claims all reached milestones.
- folder: claim always fails - rewards come from individual children.
Returns { reward, balance }. May be retried with same Idempotency-Key to get the same result.
 * @summary Claim reward for an Earn task
 */
export const earnControllerClaim = (
    id: string,
    claimTaskDto: ClaimTaskDto,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ClaimResponseDto | ClaimResponseDto>(
      {url: `/earn/tasks/${id}/claim`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: claimTaskDto, signal
    },
      options);
    }
  


export const getEarnControllerClaimMutationOptions = <TError = ErrorResponseDto | null | ErrorResponseDto | ErrorResponseDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof earnControllerClaim>>, TError,{id: string;data: ClaimTaskDto}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof earnControllerClaim>>, TError,{id: string;data: ClaimTaskDto}, TContext> => {

const mutationKey = ['earnControllerClaim'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof earnControllerClaim>>, {id: string;data: ClaimTaskDto}> = (props) => {
          const {id,data} = props ?? {};

          return  earnControllerClaim(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EarnControllerClaimMutationResult = NonNullable<Awaited<ReturnType<typeof earnControllerClaim>>>
    export type EarnControllerClaimMutationBody = ClaimTaskDto
    export type EarnControllerClaimMutationError = ErrorResponseDto | null | ErrorResponseDto | ErrorResponseDto

    /**
 * @summary Claim reward for an Earn task
 */
export const useEarnControllerClaim = <TError = ErrorResponseDto | null | ErrorResponseDto | ErrorResponseDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof earnControllerClaim>>, TError,{id: string;data: ClaimTaskDto}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof earnControllerClaim>>,
        TError,
        {id: string;data: ClaimTaskDto},
        TContext
      > => {

      const mutationOptions = getEarnControllerClaimMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Used by open_link actions to validate client navigation before `check`.
- Query params: `t` (base64url target), `ts` (epoch seconds), `sig` = HMAC_SHA256(secret, `${taskId}.${ts}.${t}`).
- TTL enforced via `ts`. Device fingerprint is recorded with the event.
Frontend obtains a pre-signed URL (generated server-side) and navigates to it; never expose the signing secret to clients.
 * @summary Redirect tracker with signature validation and event audit
 */
export const earnControllerRedirect = (
    taskId: string,
    params: EarnControllerRedirectParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<null>(
      {url: `/r/${taskId}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getEarnControllerRedirectQueryKey = (taskId?: string,
    params?: EarnControllerRedirectParams,) => {
    return [`/r/${taskId}`, ...(params ? [params]: [])] as const;
    }

    
export const getEarnControllerRedirectQueryOptions = <TData = Awaited<ReturnType<typeof earnControllerRedirect>>, TError = null | ErrorResponseDto | ErrorResponseDto>(taskId: string,
    params: EarnControllerRedirectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerRedirect>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEarnControllerRedirectQueryKey(taskId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof earnControllerRedirect>>> = ({ signal }) => earnControllerRedirect(taskId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(taskId),  staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof earnControllerRedirect>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EarnControllerRedirectQueryResult = NonNullable<Awaited<ReturnType<typeof earnControllerRedirect>>>
export type EarnControllerRedirectQueryError = null | ErrorResponseDto | ErrorResponseDto


export function useEarnControllerRedirect<TData = Awaited<ReturnType<typeof earnControllerRedirect>>, TError = null | ErrorResponseDto | ErrorResponseDto>(
 taskId: string,
    params: EarnControllerRedirectParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerRedirect>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof earnControllerRedirect>>,
          TError,
          Awaited<ReturnType<typeof earnControllerRedirect>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEarnControllerRedirect<TData = Awaited<ReturnType<typeof earnControllerRedirect>>, TError = null | ErrorResponseDto | ErrorResponseDto>(
 taskId: string,
    params: EarnControllerRedirectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerRedirect>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof earnControllerRedirect>>,
          TError,
          Awaited<ReturnType<typeof earnControllerRedirect>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEarnControllerRedirect<TData = Awaited<ReturnType<typeof earnControllerRedirect>>, TError = null | ErrorResponseDto | ErrorResponseDto>(
 taskId: string,
    params: EarnControllerRedirectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerRedirect>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Redirect tracker with signature validation and event audit
 */

export function useEarnControllerRedirect<TData = Awaited<ReturnType<typeof earnControllerRedirect>>, TError = null | ErrorResponseDto | ErrorResponseDto>(
 taskId: string,
    params: EarnControllerRedirectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerRedirect>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEarnControllerRedirectQueryOptions(taskId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns the same task payload as `/earn/sections` but scoped to one task.
- Provides current FSM state, counters and schedule for the requesting user.
- Useful when UI only needs one task without re-fetching entire sections list.
 * @summary Get a single Earn task
 */
export const earnControllerGetTask = (
    id: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<EarnTaskResponseDto>(
      {url: `/earn/tasks/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getEarnControllerGetTaskQueryKey = (id?: string,) => {
    return [`/earn/tasks/${id}`] as const;
    }

    
export const getEarnControllerGetTaskQueryOptions = <TData = Awaited<ReturnType<typeof earnControllerGetTask>>, TError = null | ErrorResponseDto | ErrorResponseDto>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerGetTask>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEarnControllerGetTaskQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof earnControllerGetTask>>> = ({ signal }) => earnControllerGetTask(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof earnControllerGetTask>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EarnControllerGetTaskQueryResult = NonNullable<Awaited<ReturnType<typeof earnControllerGetTask>>>
export type EarnControllerGetTaskQueryError = null | ErrorResponseDto | ErrorResponseDto


export function useEarnControllerGetTask<TData = Awaited<ReturnType<typeof earnControllerGetTask>>, TError = null | ErrorResponseDto | ErrorResponseDto>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerGetTask>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof earnControllerGetTask>>,
          TError,
          Awaited<ReturnType<typeof earnControllerGetTask>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEarnControllerGetTask<TData = Awaited<ReturnType<typeof earnControllerGetTask>>, TError = null | ErrorResponseDto | ErrorResponseDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerGetTask>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof earnControllerGetTask>>,
          TError,
          Awaited<ReturnType<typeof earnControllerGetTask>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEarnControllerGetTask<TData = Awaited<ReturnType<typeof earnControllerGetTask>>, TError = null | ErrorResponseDto | ErrorResponseDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerGetTask>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single Earn task
 */

export function useEarnControllerGetTask<TData = Awaited<ReturnType<typeof earnControllerGetTask>>, TError = null | ErrorResponseDto | ErrorResponseDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerGetTask>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEarnControllerGetTaskQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Primary data source for Earn UI.
- Sorted by section `rank`, and tasks by `rank`.
- Includes `server_now` plus schedule fields so UI can render countdowns to `valid_until`.
- Contains safe action descriptors (no secrets), FSM state and counters per task.
 * @summary List Earn sections and tasks
 */
export const earnControllerListSections = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<EarnSectionsResponseDto>(
      {url: `/earn/sections`, method: 'GET', signal
    },
      options);
    }
  

export const getEarnControllerListSectionsQueryKey = () => {
    return [`/earn/sections`] as const;
    }

    
export const getEarnControllerListSectionsQueryOptions = <TData = Awaited<ReturnType<typeof earnControllerListSections>>, TError = null | ErrorResponseDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerListSections>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEarnControllerListSectionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof earnControllerListSections>>> = ({ signal }) => earnControllerListSections(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof earnControllerListSections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EarnControllerListSectionsQueryResult = NonNullable<Awaited<ReturnType<typeof earnControllerListSections>>>
export type EarnControllerListSectionsQueryError = null | ErrorResponseDto


export function useEarnControllerListSections<TData = Awaited<ReturnType<typeof earnControllerListSections>>, TError = null | ErrorResponseDto>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerListSections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof earnControllerListSections>>,
          TError,
          Awaited<ReturnType<typeof earnControllerListSections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEarnControllerListSections<TData = Awaited<ReturnType<typeof earnControllerListSections>>, TError = null | ErrorResponseDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerListSections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof earnControllerListSections>>,
          TError,
          Awaited<ReturnType<typeof earnControllerListSections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEarnControllerListSections<TData = Awaited<ReturnType<typeof earnControllerListSections>>, TError = null | ErrorResponseDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerListSections>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Earn sections and tasks
 */

export function useEarnControllerListSections<TData = Awaited<ReturnType<typeof earnControllerListSections>>, TError = null | ErrorResponseDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerListSections>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEarnControllerListSectionsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Lists user's completed/claimed tasks for history or receipts.
- Use `cursor` pagination (cursor is last `taskId` seen).
- Only `filter=completed` is supported currently.
 * @summary List completed tasks
 */
export const earnControllerListCompleted = (
    params?: EarnControllerListCompletedParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<EarnControllerListCompleted200>(
      {url: `/earn/tasks`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getEarnControllerListCompletedQueryKey = (params?: EarnControllerListCompletedParams,) => {
    return [`/earn/tasks`, ...(params ? [params]: [])] as const;
    }

    
export const getEarnControllerListCompletedQueryOptions = <TData = Awaited<ReturnType<typeof earnControllerListCompleted>>, TError = null | ErrorResponseDto>(params?: EarnControllerListCompletedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerListCompleted>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEarnControllerListCompletedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof earnControllerListCompleted>>> = ({ signal }) => earnControllerListCompleted(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof earnControllerListCompleted>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EarnControllerListCompletedQueryResult = NonNullable<Awaited<ReturnType<typeof earnControllerListCompleted>>>
export type EarnControllerListCompletedQueryError = null | ErrorResponseDto


export function useEarnControllerListCompleted<TData = Awaited<ReturnType<typeof earnControllerListCompleted>>, TError = null | ErrorResponseDto>(
 params: undefined |  EarnControllerListCompletedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerListCompleted>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof earnControllerListCompleted>>,
          TError,
          Awaited<ReturnType<typeof earnControllerListCompleted>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEarnControllerListCompleted<TData = Awaited<ReturnType<typeof earnControllerListCompleted>>, TError = null | ErrorResponseDto>(
 params?: EarnControllerListCompletedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerListCompleted>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof earnControllerListCompleted>>,
          TError,
          Awaited<ReturnType<typeof earnControllerListCompleted>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEarnControllerListCompleted<TData = Awaited<ReturnType<typeof earnControllerListCompleted>>, TError = null | ErrorResponseDto>(
 params?: EarnControllerListCompletedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerListCompleted>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List completed tasks
 */

export function useEarnControllerListCompleted<TData = Awaited<ReturnType<typeof earnControllerListCompleted>>, TError = null | ErrorResponseDto>(
 params?: EarnControllerListCompletedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof earnControllerListCompleted>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEarnControllerListCompletedQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a pre-signed URL for `/r/:taskId` to validate navigation before `check`.
- Only valid for tasks of kind `open_link`.
- Frontend should navigate to the returned URL, wait a short delay, then call `check`.
Signature uses `EARN_REDIRECT_SECRET` and expires per `EARN_REDIRECT_TTL_SECONDS`.
 * @summary Generate pre-signed redirect URL (open_link)
 */
export const earnControllerGeneratePresigned = (
    id: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<GenerateRedirectResponseDto | GenerateRedirectResponseDto>(
      {url: `/earn/tasks/${id}/redirect-url`, method: 'POST', signal
    },
      options);
    }
  


export const getEarnControllerGeneratePresignedMutationOptions = <TError = ErrorResponseDto | null | ErrorResponseDto | ErrorResponseDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof earnControllerGeneratePresigned>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof earnControllerGeneratePresigned>>, TError,{id: string}, TContext> => {

const mutationKey = ['earnControllerGeneratePresigned'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof earnControllerGeneratePresigned>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  earnControllerGeneratePresigned(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EarnControllerGeneratePresignedMutationResult = NonNullable<Awaited<ReturnType<typeof earnControllerGeneratePresigned>>>
    
    export type EarnControllerGeneratePresignedMutationError = ErrorResponseDto | null | ErrorResponseDto | ErrorResponseDto

    /**
 * @summary Generate pre-signed redirect URL (open_link)
 */
export const useEarnControllerGeneratePresigned = <TError = ErrorResponseDto | null | ErrorResponseDto | ErrorResponseDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof earnControllerGeneratePresigned>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof earnControllerGeneratePresigned>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getEarnControllerGeneratePresignedMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    